import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from './App';

/* A new way to render React components. It is a new API that is available in React 16.8. */
const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(
  <App />
);


